var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "invoices-payments",
        size: "lg",
        "ok-only": true,
        "modal-class": ["custom-modal", { "no-close-icon": _vm.loading }]
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              !_vm.loading
                ? _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-secondary mr-2",
                      on: {
                        click: function($event) {
                          return _vm.hideModal()
                        }
                      }
                    },
                    [_vm._v("\n      Отменить\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit()
                        }
                      }
                    },
                    [_vm._v("\n      Сохранить\n    ")]
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.modalOpen,
        callback: function($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen"
      }
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center text-success my-2" },
            [
              _c("b-spinner", { staticClass: "align-middle" }),
              _vm._v(" "),
              _c("strong", [_vm._v("Загрузка")])
            ],
            1
          )
        : _c(
            "div",
            [
              _c("b-card", { staticClass: "custom-card" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center w-100" },
                  [
                    _c("h5", [
                      _vm._v("Оплаты счёта № " + _vm._s(_vm.newItem.numb))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: [
                          "custom-tag ml-auto mr-2",
                          _vm.getStatusStyle(_vm.newItem.paid_type)
                        ]
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getStatusName(_vm.newItem.paid_type)) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "custom-btn-primary",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onAddPayment()
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          attrs: { name: "buttons/plus", size: 12 }
                        }),
                        _vm._v("\n          Добавить\n        ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-body" },
                  [
                    _vm.isBusy ||
                    (_vm.newItem.payments && _vm.newItem.payments.length > 0)
                      ? [
                          _c(
                            "div",
                            { staticClass: "page-table-container" },
                            [
                              _c("b-table", {
                                ref: "invoice_payments",
                                staticClass: "custom-table mb-0",
                                attrs: {
                                  id: "invoice-payments",
                                  selectable: "",
                                  "select-mode": "single",
                                  responsive: "",
                                  items: _vm.newItem.payments,
                                  fields: _vm.paymentsFields,
                                  "per-page": _vm.paymentsPerPage,
                                  "current-page": _vm.paymentsCurrentPage,
                                  "sort-by": _vm.paymentsSortBy,
                                  "sort-desc": _vm.paymentsSortDesc,
                                  "no-provider-filtering": "",
                                  "no-provider-paging": "",
                                  "no-provider-sorting": ""
                                },
                                on: {
                                  "update:sortBy": function($event) {
                                    _vm.paymentsSortBy = $event
                                  },
                                  "update:sort-by": function($event) {
                                    _vm.paymentsSortBy = $event
                                  },
                                  "update:sortDesc": function($event) {
                                    _vm.paymentsSortDesc = $event
                                  },
                                  "update:sort-desc": function($event) {
                                    _vm.paymentsSortDesc = $event
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(numb)",
                                      fn: function(row) {
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input_number",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.numb,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "numb",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "row.item.numb"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(date)",
                                      fn: function(row) {
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input_date",
                                              size: "sm",
                                              type: "date"
                                            },
                                            model: {
                                              value: row.item.date,
                                              callback: function($$v) {
                                                _vm.$set(row.item, "date", $$v)
                                              },
                                              expression: "row.item.date"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(sum)",
                                      fn: function(row) {
                                        return [
                                          _c("b-form-input", {
                                            staticClass: "widthPrice",
                                            attrs: {
                                              id: "input_contract",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.sum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "sum",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "row.item.sum"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(comment)",
                                      fn: function(row) {
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input_town",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.comment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "comment",
                                                  $$v
                                                )
                                              },
                                              expression: "row.item.comment"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(action)",
                                      fn: function(row) {
                                        return [
                                          _c(
                                            "b-btn",
                                            {
                                              attrs: { variant: "link" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removePayment(row)
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "buttons/trash",
                                                  size: 16
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2782501652
                                )
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "page-pagination" },
                            [
                              _c("pagination-footer", {
                                attrs: {
                                  "total-rows": _vm.newItem.payments.length,
                                  "per-page": _vm.paymentsPerPage,
                                  "current-page": _vm.paymentsCurrentPage
                                },
                                on: {
                                  "update:currentPage": function($event) {
                                    _vm.paymentsCurrentPage = $event
                                  },
                                  "update:current-page": function($event) {
                                    _vm.paymentsCurrentPage = $event
                                  },
                                  "per-page-change": _vm.onPerPageChange
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "footer-list",
                                      fn: function() {
                                        return [
                                          _vm._v(
                                            "\n                Всего оплат: "
                                          ),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.newItem.payments.length
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            " |\n                Сумма по оплатам: "
                                          ),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.priceFormat(
                                                  _vm.totalPaymentsSum
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  3854479272
                                )
                              })
                            ],
                            1
                          )
                        ]
                      : _c(
                          "div",
                          { staticClass: "empty-state-container" },
                          [
                            _c("v-icon", {
                              attrs: { name: "navbar/empty_table", size: 90 }
                            }),
                            _vm._v(" "),
                            _c("h5", [_vm._v("Нет добавленных оплат.")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Добавьте оплаты в счёт прямо сейчас")
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-btn",
                              {
                                staticClass: "custom-btn-primary mt-1",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onAddPayment()
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  staticClass: "mr-1",
                                  attrs: { name: "buttons/plus", size: 12 }
                                }),
                                _vm._v("\n            Новая оплата\n          ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ],
                  2
                )
              ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12e9365c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e9365c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/InvoicesPayments.vue
// module id = null
// module chunks = 